/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const isHomeNav = navigation.classList.contains('melo-nav-centered');
    const dropdown = navigation.querySelector('.melo-nav-dropdown');
    const dropdownInner = navigation.querySelector('.melo-nav-dropdown-inner');
    const mobileQuery = window.matchMedia('(max-width: 991px)');
    const MENU_MS = 280;
    let menuAnimating = false;

    function normalizePath(path) {
        return path.replace(/\/+$/, '') || '/';
    }

    function isBlogListingPage() {
        if (document.querySelector('.melo-blog-page') || document.querySelector('.melo-blog-reader')) {
            return true;
        }

        const path = normalizePath(window.location.pathname);
        return path === '/blog' || /^\/blog(\/|$)/.test(path);
    }

    function disableNavItem(link) {
        if (!link || link.tagName !== 'A' || link.classList.contains('melo-nav-item--current')) {
            return;
        }

        const span = document.createElement('span');
        span.className = 'melo-nav-item melo-nav-item--current';
        span.setAttribute('aria-current', 'page');
        span.textContent = link.textContent.trim();
        link.replaceWith(span);
    }

    if (dropdownInner) {
        const currentPath = normalizePath(window.location.pathname);
        const pricingLink = dropdownInner.querySelector('a.melo-nav-item[href*="/pricing"]');
        const blogLink = dropdownInner.querySelector('a.melo-nav-item[href*="/blog"]');

        if (
            pricingLink &&
            normalizePath(new URL(pricingLink.href, window.location.origin).pathname) ===
                currentPath
        ) {
            disableNavItem(pricingLink);
        }

        if (blogLink && isBlogListingPage()) {
            disableNavItem(blogLink);
        }
    }

    const navLinks = navigation.querySelectorAll('.melo-nav-dropdown a.melo-nav-item');

    function useAnimatedMenu() {
        return (
            isHomeNav &&
            mobileQuery.matches &&
            dropdown &&
            dropdownInner
        );
    }

    function openAnimatedMenu() {
        navigation.classList.remove('is-closing');
        navigation.classList.add('is-open', 'is-entering');
        burger.setAttribute('aria-expanded', 'true');
        dropdown.style.height = '';
        dropdown.style.opacity = '';

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                navigation.classList.remove('is-entering');
            });
        });
    }

    function closeAnimatedMenu() {
        if (!navigation.classList.contains('is-open') || menuAnimating) return;

        menuAnimating = true;
        burger.setAttribute('aria-expanded', 'false');
        navigation.classList.remove('is-entering');
        navigation.classList.add('is-closing');

        var finished = false;

        function done() {
            if (finished) return;
            finished = true;
            navigation.classList.remove('is-open', 'is-closing', 'is-entering');
            dropdown.style.height = '';
            dropdown.style.opacity = '';
            menuAnimating = false;
            document.dispatchEvent(new CustomEvent('melo-nav-menu-closed'));
        }

        window.setTimeout(done, MENU_MS);
    }

    function setMenuOpen(isOpen) {
        if (useAnimatedMenu()) {
            if (isOpen) openAnimatedMenu();
            else closeAnimatedMenu();
            return;
        }

        navigation.classList.toggle('is-open', isOpen);
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (!isOpen) {
            document.dispatchEvent(new CustomEvent('melo-nav-menu-closed'));
        }

        if (!isHomeNav) {
            document.documentElement.style.overflowY = isOpen ? 'hidden' : null;
        }
    }

    burger.addEventListener('click', function () {
        setMenuOpen(!navigation.classList.contains('is-open'));
    });

    navLinks.forEach(function (link) {
        link.addEventListener('click', function () {
            if (isHomeNav) {
                setMenuOpen(false);
            }
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
            setMenuOpen(false);
        }
    });

    function handleViewportChange() {
        if (!mobileQuery.matches && navigation.classList.contains('is-open')) {
            setMenuOpen(false);
            if (dropdown) {
                dropdown.style.height = '';
                dropdown.style.opacity = '';
            }
        }
    }

    mobileQuery.addEventListener('change', handleViewportChange);

    document.addEventListener('melo-nav-request-close-menu', function () {
        if (navigation.classList.contains('is-open')) {
            setMenuOpen(false);
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    if (document.body.classList.contains('home-template')) {
        return;
    }

    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
